import { useMutation } from '@apollo/client'
import { PaymentInsurance, PaymentInsuranceVariables } from '../../types'
import { CREATE_EVENT_INSURANCE_PAYMENT } from './operations'

export const useCreateEventInsurancePayment = () =>
  useMutation<PaymentInsurance, PaymentInsuranceVariables>(CREATE_EVENT_INSURANCE_PAYMENT)
